import { render } from "./SignXero.vue?vue&type=template&id=3147fcd1"
import script from "./SignXero.vue?vue&type=script&lang=js"
export * from "./SignXero.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__